import {LiquidationStatus} from "./LiquidationStatus";

export const LiquidationStatusNames: Record<LiquidationStatus, string> = {
  [LiquidationStatus.IN_PROGRESS]: "En Progreso",
  [LiquidationStatus.SUBMITTED]: "Enviada",
  [LiquidationStatus.TO_FIX]: "A Corregir",
  [LiquidationStatus.CLOSE]: "Cerrada",
};
